import React from 'react';
import styles from "./styles.module.scss";
import { CloseCircleGreyIcon } from 'assets';
import { Button } from 'components/button';
import { useClickOutside } from 'hooks';

interface DeleteSectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  sectionName?: string;
}

export const DeleteSectionModal: React.FC<DeleteSectionModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  sectionName
}) => {
  const modalRef = React.useRef(null);
  useClickOutside(modalRef, onClose);

  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className={styles.modalOverlay}>
      <div ref={modalRef} className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <button onClick={onClose} className={styles.closeButton}>
            <CloseCircleGreyIcon />
          </button>
        </div>

        <div className={styles.modalBody}>
          <div className={styles.warningIcon}>
            <div className={styles.exclamationMark}>!</div>
          </div>
          
          <h2 className={styles.modalTitle}>Deleting a Section</h2>
          
          <p className={styles.modalDescription}>
            You are about to delete a section. This section won't be used to create the assessment criteria. Are you sure?
          </p>
        </div>

        <div className={styles.modalFooter}>
          <Button
            className={styles.cancelButton}
            type="outline"
            onClick={onClose}
          >
            Cancel
          </Button>
          <button 
            onClick={handleConfirm} 
            className={styles.confirmButton}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};